class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* Quick-cart upsell slider + Ajax add. */
(() => {
  if (window.__datanovaQuickCartUpsellSliderLoaded) return;
  window.__datanovaQuickCartUpsellSliderLoaded = true;

  const sliderSelector = '[data-quick-cart-upsell-slider]';

  function initSlider(slider) {
    if (!slider || slider.dataset.sliderReady === 'true') return;

    const track = slider.querySelector('[data-quick-cart-upsell-track]');
    const originalSlides = Array.from(slider.querySelectorAll('[data-quick-cart-upsell-slide]'));
    const container = slider.closest('.quick-cart-accessories');
    const prevButton = container?.querySelector('[data-quick-cart-upsell-prev]');
    const nextButton = container?.querySelector('[data-quick-cart-upsell-next]');
    const dots = Array.from(slider.querySelectorAll('[data-quick-cart-upsell-dot]'));

    if (!track || originalSlides.length === 0) return;

    slider.dataset.sliderReady = 'true';

    const slideCount = originalSlides.length;
    const isInfinite = slideCount > 1;
    const autoplay = slider.dataset.autoplay === 'true' && isInfinite;
    const autoplaySpeed = Math.max(2000, Number(slider.dataset.autoplaySpeed) || 4000);
    const transitionValue = 'transform .42s cubic-bezier(.22, .61, .36, 1)';

    let logicalIndex = 0;
    let visualIndex = isInfinite ? 1 : 0;
    let autoplayTimer = null;
    let transitionLocked = false;
    let touchStartX = null;

    if (isInfinite) {
      const firstClone = originalSlides[0].cloneNode(true);
      const lastClone = originalSlides[slideCount - 1].cloneNode(true);

      firstClone.dataset.quickCartUpsellClone = 'first';
      lastClone.dataset.quickCartUpsellClone = 'last';
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');

      track.insertBefore(lastClone, originalSlides[0]);
      track.appendChild(firstClone);
    }

    const allSlides = () => Array.from(track.children);

    const setTransition = (enabled) => {
      track.style.transition = enabled ? transitionValue : 'none';
    };

    const setPosition = (index, animate = true) => {
      setTransition(animate);
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
    };

    const updateDots = () => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === logicalIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const syncLogicalFromVisual = () => {
      if (!isInfinite) {
        logicalIndex = 0;
      } else if (visualIndex === 0) {
        logicalIndex = slideCount - 1;
      } else if (visualIndex === slideCount + 1) {
        logicalIndex = 0;
      } else {
        logicalIndex = visualIndex - 1;
      }
      updateDots();
    };

    const jumpWithoutAnimation = (nextVisualIndex) => {
      visualIndex = nextVisualIndex;
      setTransition(false);
      track.style.transform = `translate3d(-${visualIndex * 100}%, 0, 0)`;
      // Force layout so the next user/autoplay movement animates normally.
      void track.offsetWidth;
      setTransition(true);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay || document.hidden) return;
      autoplayTimer = window.setInterval(() => moveBy(1, false), autoplaySpeed);
    };

    const restartAutoplay = () => {
      if (autoplay) startAutoplay();
    };

    const moveBy = (direction, userInitiated = true) => {
      if (!isInfinite || transitionLocked) return;

      transitionLocked = true;
      visualIndex += direction;
      syncLogicalFromVisual();
      setPosition(visualIndex, true);

      if (userInitiated) restartAutoplay();
    };

    const goToLogical = (targetLogicalIndex, userInitiated = true) => {
      if (!isInfinite || transitionLocked) return;

      const safeTarget = ((targetLogicalIndex % slideCount) + slideCount) % slideCount;
      logicalIndex = safeTarget;
      visualIndex = safeTarget + 1;
      transitionLocked = true;
      updateDots();
      setPosition(visualIndex, true);

      if (userInitiated) restartAutoplay();
    };

    track.addEventListener('transitionend', (event) => {
      if (event.propertyName !== 'transform') return;

      if (isInfinite && visualIndex === slideCount + 1) {
        jumpWithoutAnimation(1);
        logicalIndex = 0;
      } else if (isInfinite && visualIndex === 0) {
        jumpWithoutAnimation(slideCount);
        logicalIndex = slideCount - 1;
      }

      updateDots();
      transitionLocked = false;
    });

    prevButton?.addEventListener('click', () => moveBy(-1, true));
    nextButton?.addEventListener('click', () => moveBy(1, true));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goToLogical(Number(dot.dataset.quickCartUpsellDot) || 0, true);
      });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    slider.addEventListener('touchstart', (event) => {
      touchStartX = event.touches?.[0]?.clientX ?? null;
      stopAutoplay();
    }, { passive: true });

    slider.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
      const distance = endX - touchStartX;

      if (Math.abs(distance) > 35) {
        moveBy(distance < 0 ? 1 : -1, true);
      } else {
        startAutoplay();
      }

      touchStartX = null;
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopAutoplay() : startAutoplay();
    });

    allSlides().forEach((slide, index) => {
      if (index !== visualIndex) slide.setAttribute('aria-hidden', 'true');
    });

    setPosition(visualIndex, false);
    void track.offsetWidth;
    setTransition(true);
    updateDots();
    startAutoplay();
  }

  function initAll(root = document) {
    if (root.matches?.(sliderSelector)) initSlider(root);
    root.querySelectorAll?.(sliderSelector).forEach(initSlider);
  }

  async function addUpsellProduct(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding…';

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product.');

      const refreshDrawer = (cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((node) => {
          node.textContent = cart.item_count;
        });

        document.body.classList.add('cart-sidebar-show');

        if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          window.sharedFunctions.updateSidebarCart(cart);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      };

      if (window.Shopify && typeof window.Shopify.getCart === 'function') {
        window.Shopify.getCart(refreshDrawer);
      } else {
        const cartUrl = `${String(window.routes?.cart_url || '/cart').replace(/\/$/, '')}.js`;
        const cartResponse = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
        refreshDrawer(await cartResponse.json());
      }
    } catch (error) {
      console.error('[Quick cart upsell]', error);
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quick-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addUpsellProduct(button);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initAll(node);
      });
    });
  });

  const start = () => {
    initAll();
    const drawer = document.querySelector('#halo-cart-sidebar');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
